export const STORED_DIALOG_STRUCTURE = 'StoredDialogStructure';
export const CONVERSATION_HISTORY_SCROLL = 'ConversationHistory_ScrollY';
export const USERS_SUBSCRIPTION = 'UsersSubscription';
